import { gql } from '@common/hooks';

export const TimeZonesQuery = gql`
  query TimeZones {
    timeZones {
      text
      value
    }
  }
`;

export type TimeZonesQueryResponse = {
  timeZones: {
    text: string;
    value: string;
  }[];
};
